/**
 * Notification & verification endpoints
 */

import type { ApiEndpoint } from '../endpointsConfig'

export const notificationEndpoints: ApiEndpoint[] = [
  {
    name: 'verificationSendCode',
    path: 'restohub-api/notifications/verify/send-code/',
    actions: ['POST'],
    tags: ['Verification'],
  },
  {
    name: 'verificationConfirmCode',
    path: 'restohub-api/notifications/verify/confirm-code/',
    actions: ['POST'],
    tags: ['Verification'],
  },
]
